/* global angular */
( function () {
	'use strict';

	function pdfCommonFactory () {
		function horizontalRule ( thickness, marginArr ) {
			var hr = {
				'margin'  : marginArr || [ 0, 0, -40, 0 ],
				'columns' : [
					{
						'table' : {
							'widths' : [ '*' ],
							'body'   : [ [ ' ' ], [ ' ' ] ],
							'margin' : [ 0, 0, 0, 0 ]
						},

						'layout' : {
							'hLineWidth' : function ( i, node ) {
								var retValue = thickness || 2;

								if ( i === 0 || i === node.table.body.length ) {
									retValue = 0;
								}

								return retValue;
							},
							'vLineWidth' : function () {
								return 0;
							}
						}
					}
				]
			};

			return hr;
		}

		function pdfStyles () {
			return {
				'tableHeader' : {
					'bold'      : true,
					'margin'    : [ 0, 5, 0, 5 ],
					'alignment' : 'center'
				},

				'header' : {
					'margin' : [ 5, 0, 0, -10 ]
				},

				'obsTplHeaderKey' : {
					'color'     : 'gray',
					'fontSize'  : 9,
					'alignment' : 'left',
					'bold'      : true,
					'margin'    : [ 0, 3, 0, 0 ]
				},

				'obsTplHeaderValue' : {
					'fontSize'  : 10,
					'alignment' : 'left',
					'margin'    : [ 0, 3, 0, 0 ]
				},

				'frontPageHeaderKey' : {
					'color'     : 'gray',
					'fontSize'  : 9,
					'alignment' : 'right',
					'bold'      : true,
					'margin'    : [ 0, 3, 0, 0 ]
				},

				'frontPageHeaderValue' : {
					'alignment' : 'left',
					'fontSize'  : 10,
					'margin'    : [ 5, 3, 0, 0 ]
				},

				'pdStatusUserReportHeader' : {
					'fontSize'  : 10,
					'bold'      : true,
					'alignment' : 'left',
					'margin'    : [ 0, 0, 0, 5 ]
				},

				'pdStatusUserReportHeaderProgress' : {
					'fontSize'  : 10,
					'bold'      : true,
					'alignment' : 'right'
				},

				'obsStatusUserReportHeader' : {
					'fontSize'  : 10,
					'bold'      : true,
					'alignment' : 'left',
					'margin'    : [ 0, 0, 0, 5 ]
				},

				'label' : {
					'margin' : [ 0, 5, 0, 5 ]
				},

				'groupTitle' : {
					'bold'     : true,
					'fontSize' : 11,
					'margin'   : [ 0, 5, 0, 5 ]
				},

				'groupContainer' : {
					'margin' : [ 0, 15, 0, 0 ]
				},

				'questionText' : {
					'fontSize' : 10,
					'margin'   : [ 10, 12, 0, 5 ]
				},

				'answerText' : {
					'fontSize' : 9,
					'margin'   : [ 30, 5, 0, 4 ]
				},

				'rubricTitle' : {
					'fontSize' : 10
				},

				'rubricDescription' : {
					'fontSize' : 9
				},

				'answerSubOptions' : {
					'fontSize' : 9,
					'margin'   : [ 45, 5, 0, 4 ]
				},

				'signatureLabel' : {
					'fontSize'  : 10,
					'alignment' : 'center'
				},

				'groupScore' : {
					'fontSize' : 10,
					'italics'  : true,
					'bold'     : false
				},

				'ObsScore' : {
					'italics'   : true,
					'alignment' : 'left',
					'margin'    : [ 0, 15, 20, 15 ]
				},

				'answerHeaderText' : {
					'italics'   : true,
					'alignment' : 'left',
					'margin'    : [ 20, 7, 0, 7 ]
				},

				'answerHeaderScore' : {
					'italics'   : true,
					'fontSize'  : 9,
					'alignment' : 'right',
					'margin'    : [ 15, 7, 20, 7 ]
				},

				'evidence' : {
					'fontSize' : 9,
					'margin'   : [ 10, 12, 0, 5 ]
				},

				'sectionEvidence' : {
					'margin' : [ 0, 4, 0, 5 ]
				},

				'indicatorEvidence' : {
					'margin' : [ 10, 5, 0, 4 ]
				},

				'ObsStatusUserReportHeader' : {
					'fontSize'  : 11,
					'bold'      : true,
					'alignment' : 'left',
					'margin'    : [ 0, 0, 0, -13 ]
				},

				'ObsStatusStatisticsBody' : {
					'fontSize' : 10,
					'margin'   : [ 0, -10, 0, 15 ]
				},

				'evidenceTitle' : {
					'fontSize' : 9
				},

				'graphTitle' : {
					'fontSize'  : 12,
					'bold'      : true,
					'alignment' : 'center',
					'margin'    : [ 0, 15, 0, 3 ]
				},

				'graphSubtitle' : {
					'fontSize'  : 10,
					'alignment' : 'center',
					'margin'    : [ 0, 3, 0, 15 ]
				},

				'feedbackTableHeader' : {
					'bold'   : true,
					'margin' : [ 3, 0, 3, 0 ]
				},

				'feedbackHeader' : {
					'bold'     : true,
					'margin'   : [ 0, 3, 0, 3 ],
					'fontSize' : 11
				},

				'attachedPd' : {
					'fontSize' : 9,
					'margin'   : [ 4, -1, 0, 5 ]
				}
			};
		}

		function generateLogo () {
			var imageObj = {
				'image'  : 'sinet-logo.jpg',
				'width'  : 14,
				'margin' : [ 0, 0, 5, -15 ]
			};

			return imageObj;
		}

		function createHeader ( addedString ) {
			var header = {
				'columns' : [ generateLogo(), {
					'text'  : 'Edivate Observe' + ( ( addedString || '' ) && ' - ' ) + ( addedString  || '' ),
					'style' : 'header'
				} ]
			};

			return header;
		}

		function stripHTML ( text ) {
			// replace `<br>` with `\n` and strip all other html
			return String( text ).replace( /<br\s*[\/]?>/gi, '\n' ).replace( /<[^>]+>/gm, '' );
		}

		function templateReportOptr ( showOptions, templateBody ) {
			function removeArrayElem ( index ) {
				return function ( arr ) {
					arr.stack.map( function ( item ) {
						item.stack.splice( index, 1, null );
					} );
				};
			}

			function removeObsDetails ( arr ) {
				removeArrayElem( 3 )( arr );
				removeArrayElem( 4 )( arr );
				removeArrayElem( 5 )( arr );
			}

			var showOptionsFnObj = {
				'Observation Details'             : removeObsDetails,
				'Scoring'                         : removeArrayElem( 1 ),
				'Evidence'                        : angular.noop,
				'Rubric proficiency descriptions' : angular.noop,
				'Signature Lines'                 : removeArrayElem( 2 ),
				'Feedback'                        : angular.noop
			};

			Object.keys( showOptions ).filter( function ( key ) {
				return !showOptions[ key ];
			} ).forEach( function ( key ) {
				showOptionsFnObj[ key ]( templateBody.stack[ 1 ] );
			} );
		}

		function extractAttrToArr ( objArr, attr ) {
			return objArr.map( function ( item ) {
				return item[ attr ];
			} );
		}

		return {
			'createHeader'       : createHeader,
			'horizontalRule'     : horizontalRule,
			'pdfStyles'          : pdfStyles,
			'stripHTML'          : stripHTML,
			'templateReportOptr' : templateReportOptr,
			'extractAttrToArr'   : extractAttrToArr
		};
	}

	angular
		.module( 'app.components' )
		.factory( 'pdfCommonFactory', pdfCommonFactory );
} )();
